// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j63x","type":"styles_type__rtgQm","choices":"styles_choices__3NinS"};